import { render } from "./assessment-desktop.vue?vue&type=template&id=5feef85b&ts=true"
import script from "./assessment-desktop.vue?vue&type=script&lang=ts"
export * from "./assessment-desktop.vue?vue&type=script&lang=ts"

import "./assessment-desktop.vue?vue&type=style&index=0&id=5feef85b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__